import { URL_API } from "../../url.config";
import { request } from "../../utils/apiUtils";

// Module "Xem nhanh" (Quick Access) — shortcut cá nhân hóa per-user.
// Contract: ba-shared/api-contracts/quick-access/. Owner do server lấy từ Bearer token
// (UserSession.uuid), client KHÔNG gửi userId. Mọi response bọc BaseResponse<T>.
const BASE = `${URL_API}/api/sas-school/quick-access`;

const QuickAccess = {
    // GET /list -> BaseResponse<QuickAccessRes[]>
    getMyQuickAccess: (callback) =>
        request({ url: `${BASE}/list`, method: 'GET', timeoutMs: 10000 }, callback),

    // POST / -> BaseResponse<QuickAccessRes>
    createQuickAccess: (payload, callback) =>
        request({ url: BASE, method: 'POST', body: payload }, callback),

    // PUT /{id} -> BaseResponse<QuickAccessRes>
    updateQuickAccess: (id, payload, callback) =>
        request({ url: `${BASE}/${id}`, method: 'PUT', body: payload }, callback),

    // DELETE /{id} -> BaseResponse<Boolean>
    deleteQuickAccess: (id, callback) =>
        request({ url: `${BASE}/${id}`, method: 'DELETE' }, callback),

    // POST /reorder -> BaseResponse<Boolean>
    reorderQuickAccess: (ids, callback) =>
        request({ url: `${BASE}/reorder`, method: 'POST', body: { ids } }, callback),
};

export default QuickAccess;
